import PrivateRoute from './PrivateRoute';
export { PrivateRoute };
export default PrivateRoute;
